import React, { useEffect, useState, useCallback, useRef } from 'react'
import useApp from 'hooks/useApp'
import { Button, Input, InputRed, Select } from 'components'
import styles from './index.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import useSecureKeypad from 'hooks/useSecureKeypad'
import Lib from 'library'
import Native from 'library/native'

const DataPwSetting = () => {

	const App = useApp()
	const location = useLocation()
	const sno = location?.state?.sno
	const navigate = useNavigate();

	const [passwordCheck, setPasswordCheck] = useState(false)
	const [dateCheck, setDateCheck] = useState(false)
	const [passwordError, setPasswordError] = useState(false)
	const [certRedText, setCertRedText] = useState("입력하신 비밀번호가 일치하지 않아요.") // 오류 문구

	const [dateType, setDateType] = useState();
	const [dateLst] = useState([
		{
			key: "1시간",
			value: 1,
			lst: { avlUnit: "H", avlTerm: 1 }
		},
		{
			key: "6시간",
			value: 6,
			lst: { avlUnit: "H", avlTerm: 6 }
		},
		{
			key: "12시간",
			value: 12,
			lst: { avlUnit: "H", avlTerm: 12 }
		},
		{
			key: "24시간",
			value: 24,
			lst: { avlUnit: "H", avlTerm: 24 }
		},
		{
			key: "3일",
			value: 3,
			lst: { avlUnit: "D", avlTerm: 3 }
		},
		{
			key: "7일",
			value: 7,
			lst: { avlUnit: "D", avlTerm: 7 }
		},
		{
			key: "15일",
			value: 15,
			lst: { avlUnit: "D", avlTerm: 15 }
		},
		{
			key: "한달",
			value: 31,
			lst: { avlUnit: "D", avlTerm: 31 }
		}
	])

	// TODO: 보안키패드 사용 
	// TODO: /api/data/crtf/save API 진행시 secId, secToken, secInput 로컬에서 값 확인 불가
	// TODO: 지금 현재 로컬은 module.get_input(), module2.get_input() 값으로 진행 (앱 테스트시 삭제)


	const [disabled, setDisabled] = useState(true)

	const pass1 = useRef(null)
	const pass2 = useRef(null)

	const [module, showKeypad] = useSecureKeypad()
	const [module2, showKeypad2] = useSecureKeypad()

	const [avlTerm, setAvlTerm] = useState()
	const [avlUnit, setAvlUnit] = useState()

	const [timeCheck, setTimeCheck] = useState(false)

	const onDateSelect = useCallback((key, value) => {
		const _data = dateLst.find(v => v.value === value)
		const _avlTerm = _data.lst.avlTerm
		const _avlUnit = _data.lst.avlUnit

		setAvlTerm(_avlTerm)
		setAvlUnit(_avlUnit)
		setDateType(_data.value)

		setTimeCheck(true)

	}, [avlTerm, avlUnit])

	useEffect(() => {
		if (passwordCheck && dateCheck && timeCheck) setDisabled(false)
	}, [passwordCheck, dateCheck, timeCheck])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	// 비밀번호 입력
	const clickPwInput = (e) => {
		e.target.value = ""
		showKeypad({
			input: e.target,
			onShow: () => {
				setPasswordCheck(false)
				setDateCheck(false)
				setPasswordError(false)
			},
			onChange: (length) => {
				const info = module.get_sessionInfo()
				// || module.get_input(); // TODO: 앱 테스트 진행시 module.get_input() 삭제
				pass1.current = info
				setPasswordCheck(length === 6)
			}
		})
	}

	// 비밀번호 확인
	const clickCheckPwInput = (e) => {
		e.target.value = ""

		showKeypad2({
			input: e.target,
			onShow: () => {
				setDateCheck(false)
			},
			onChange: (length) => {
				const info = module2.get_sessionInfo()
				//  || module2.get_input(); // TODO: 앱 테스트 진행시 module.get_input() 삭제

				pass2.current = info

				if (length === 6) {
					setDateCheck(true)
				}
			}
		})
	}

	const onSave = useCallback(() => {
		const crtf = {
			avlTerm: avlTerm,
			avlUnit: avlUnit,
			secId: pass1.current.sessionId,
			secId2: pass2.current.sessionId,
			secInput: pass1.current.input,
			secInput2: pass2.current.input,
			secToken: pass1.current.secToken,
			secToken2: pass2.current.secToken,
			// "pw": module.get_input() || "", // TODO: 앱 테스트 진행시 삭제
			// "pwRe": module2.get_input() || "", // TODO: 앱 테스트 진행시 삭제
			sno: sno
			//  || "220425161551508" // TODO: 앱 테스트 진행시 (220425161551508) 삭제
		}

		console.log("sno:" + sno);

		Lib.post({
			url: `/api/data/crtf/save`,
			onSuccess: data => {
				setPasswordError(false)
				const args ={
					type: "url",
					data: `https://app.moneey.co.kr/landing.html?sid=${sno}`,
//					data: `https://app.moneey.co.kr/moneey-landing/${sno}`,
					// data: App.device.os?.toLowerCase() === "android" ?
					// 	`https://app.moneey.co.kr/moneey-landing/${sno}`
					// 	: `moneey://dataCertificate?id=${sno}`,
					title: "모니 데이터증명서 공유 링크"
				}
				// 공유하기 네이티브 호출
				Lib.nativeCall("AppManager", "sharePlus", args, (result) => {
					const json = JSON.parse(result);
					console.log(json.result);
					navigate("/home/dataList")
				});
			},
			onFail: res => {
				console.log(res)
				if (res.code === "E000") {
					setPasswordError(true)
					setCertRedText("입력하신 비밀번호가 일치하지 않습니다.")
				} else if (res.code === "E001") {
					setPasswordError(true)
					setCertRedText("동일한 숫자 3자리 이상 사용할 수 없습니다.")
				} else if (res.code === "E002") {
					setPasswordError(true)
					setCertRedText("연속된 숫자 3자리 이상 사용할 수 없습니다.")
				} else if (res.code === "E003") {
					setPasswordError(true)
					setCertRedText("전화번호가 포함된 비밀번호는 사용할 수 없습니다.")
				} else if (res.code === "E004") {
					setPasswordError(true)
					setCertRedText("생년월일이 포함된 비밀번호는 사용할 수 없습니다.")
				}
				// 로컬에서는 키보드 보안 실패하므로, E005 에서 동작확인하고 싶으면 이곳에 작성
				//setPasswordError(false)
				// const args ={
				// 	type: "url",
				// 	data: `moneey://dataCertificate?id=${sno}`,
				// 	title: "모니 데이터증명서 공유 링크"
				// }
				// // 공유하기 네이티브 호출
				// Lib.nativeCall("AppManager", "sharePlus", args, (result) => {
				// 	const json = JSON.parse(result);
				// 	console.log(json.result);
				// 	navigate("/home/dataList")
				// });

			},
			onError: ({ res }) => {
				if (!res) {
					App.alert("응답이 없습니다.")
					return
				}
				console.log(res.data.code, res.data.msg)
				let msg
				if (res.data.msg) {
					msg = `${res.data.code}: ${res.data.msg}`
				} else {
					msg = "알수 없는 오류가 발생했습니다.<br />다시 시도해 주세요."
				}
				App.alert(msg)
			},
			data: crtf
		})

	}, [pass1, pass2, sno, avlTerm, avlUnit])

	return (
		<div className="page">
			<div className="flex_1 padding">

				<h3>정보 보안을 위해<br />비밀번호와 시간을 설정해주세요.</h3>
				<p className="mt_20 guide-title">비밀번호 설정은 공유 받는 사람이 증명서 확인 전<br />
					입력해야하는 비밀번호에요.
				</p>

				<p className="mt_20 guide-title">비밀번호 설정 후<br />
					<strong className="text-red">증명서를 공유 받는 사람</strong>에게 꼭! 알려주세요.
				</p>

				<p className="guide-title mt_40">비밀번호 입력</p>
				<Input
					readOnly
					id=""
					className="px_10 mt_10"
					type="password"
					placeholder="비밀번호 6자리 입력"
					maxlength="6"
					onClick={clickPwInput}
				/>

				{passwordCheck
					&& <>
						<p className="guide-title mt_40">비밀번호 확인</p>
						<Input
							readOnly
							id=""
							className="px_10 mt_10"
							type="password"
							placeholder="비밀번호 6자리 입력"
							maxlength="6"
							onClick={clickCheckPwInput}
						/>
						<InputRed text={certRedText} show={passwordError} />
					</>
				}

				{dateCheck &&
					<>
						<div className={`${styles.notice} mt_20`}>
							<p>정보 열람기간 제한 설정</p>
							<span className="mt_10">- 설정한 기간 내에만 정보를 열람할 수 있어요.</span>
						</div>
						<p className="guide-title mt_20">정보 열람기간 설정</p>
						<Select
							className="mt_10"
							placeholder="선택"
							title="기간 선택"
							selected={dateType}
							data={dateLst.map((item, index) => ({ key: item.key, value: item.value }))}
							onSelect={(key, value) => onDateSelect(key, value)}
						>
						</Select>

					</>
				}
			</div>
			<div className="padding flex-shrink_0 pt_0">
				<Button className="btn btn--big" disabled={disabled} onClick={onSave}>다음</Button>
			</div>
		</div>
	)
}

export default DataPwSetting
